var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28.021,
    viewBox: "0 0 28 28.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#003d5b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.039,6.214a2.3,2.3,0,0,0-3.14.841L21.86,10.588V7.662a.547.547,0,0,0-1.095,0v4.821L14.755,22.894a.542.542,0,0,0-.07.215l-.412,3.817H1.283V1.095H20.766V2.736a.547.547,0,0,0,1.095,0V.547A.547.547,0,0,0,21.313,0H.735A.547.547,0,0,0,.188.547V27.473a.547.547,0,0,0,.547.547H21.313a.547.547,0,0,0,.547-.547V19.781L27.881,9.354a2.3,2.3,0,0,0-.842-3.14ZM15.683,24.062l1.578.911L15.442,26.3Zm5.083,2.864H16.442l2.143-1.566a.555.555,0,0,0,.151-.168l2.029-3.515Zm-2.7-2.755-2.086-1.2,8.01-13.874,2.085,1.2Zm8.87-15.365-.313.543-2.085-1.2.313-.543a1.2,1.2,0,1,1,2.085,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M376.735,85a.547.547,0,1,0,.387.16A.551.551,0,0,0,376.735,85Z",
    transform: "translate(-355.422 -80.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M98.79,106H87.735a.547.547,0,1,0,0,1.095H98.79a.547.547,0,1,0,0-1.095Z",
    transform: "translate(-82.239 -100.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M98.79,162H87.735a.547.547,0,1,0,0,1.095H98.79a.547.547,0,1,0,0-1.095Z",
    transform: "translate(-82.239 -153.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M219.549,218h-4.064a.547.547,0,1,0,0,1.095h4.064a.547.547,0,0,0,0-1.095Z",
    transform: "translate(-202.997 -206.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.338,274.547A.547.547,0,0,0,98.79,274H87.735a.547.547,0,0,0,0,1.095H98.79A.547.547,0,0,0,99.338,274.547Z",
    transform: "translate(-82.239 -259.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M188.2,330.547a.547.547,0,0,0-.547-.547h-3.42a.547.547,0,1,0,0,1.095h3.42A.547.547,0,0,0,188.2,330.547Z",
    transform: "translate(-173.457 -311.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.735,387.095h4.816a.547.547,0,1,0,0-1.095H87.735a.547.547,0,1,0,0,1.095Z",
    transform: "translate(-82.239 -364.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.735,219.095h3.648a.547.547,0,0,0,0-1.095H87.735a.547.547,0,1,0,0,1.095Z",
    transform: "translate(-82.239 -206.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.735,331.095h2.818a.547.547,0,1,0,0-1.095H87.735a.547.547,0,1,0,0,1.095Z",
    transform: "translate(-82.239 -311.94)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText);
export default __webpack_public_path__ + "static/media/iconText.25a90f872fe8fc50c137bc11cf999de8.svg";
export { ForwardRef as ReactComponent };